import { ADD_CARD_TO_DECK, ADD_CARD_TO_DECK_ERROR, ADD_CARD_TO_DECK_SUCCESS, API_ERROR, CLOSE_EDIT_DECK_CARD, CLOSE_EDIT_DECK_CARD_SUCCESS, FETCH_DECK_CARDS, FETCH_DECK_CARDS_ERROR, FETCH_DECK_CARDS_SUCCESS, FETCH_ONE_DECK_CARD, FETCH_ONE_DECK_CARD_ERROR, FETCH_ONE_DECK_CARD_SUCCESS, FETCH_UNPARENTED_CARDS, FETCH_UNPARENTED_CARDS_ERROR, FETCH_UNPARENTED_CARDS_SUCCESS, REMOVE_CARD_FROM_DECK, REMOVE_CARD_FROM_DECK_ERROR, REMOVE_CARD_FROM_DECK_SUCCESS, SAVE_DECK_CARD, SAVE_DECK_CARD_ERROR, SAVE_DECK_CARD_SUCCESS, SORT_DECK_CARDS, SORT_DECK_CARDS_ERROR, SORT_DECK_CARDS_SUCCESS } from "../constants/ActionTypes";
import { apiV2, errorHandler } from ".";
import Swal from "sweetalert2";
import { toast } from "../utils/v2Toast";


export function fetchAllCards(deckId) {
    return function (dispatch) {
        dispatch({
            type: FETCH_DECK_CARDS
        });

        apiV2.get(`/decks/${deckId}/cards`)
            .then((response) => {
                dispatch({
                    type: FETCH_DECK_CARDS_SUCCESS,
                    payload: response.data.objects
                })
            })
            .catch((error) => {
                dispatch({
                    type: FETCH_DECK_CARDS_ERROR,
                    payload: []
                });
                errorHandler(dispatch, error.response, API_ERROR);
            })
    }
}

export function fetchUnparentedCards() {
    return function (dispatch) {
        dispatch({
            type: FETCH_UNPARENTED_CARDS
        });

        apiV2.get(`/decks/cards`)
            .then((response) => {
                const unparented = (response.data.objects || []).filter(card => card.deck_id === null);
                dispatch({
                    type: FETCH_UNPARENTED_CARDS_SUCCESS,
                    payload: unparented
                })
            })
            .catch((error) => {
                dispatch({
                    type: FETCH_UNPARENTED_CARDS_ERROR,
                    payload: []
                });
                errorHandler(dispatch, error.response, API_ERROR);
            })
    }
}

// fetchOneCard removed — edit pages fetch directly via apiV2

export function closeEditCard(deckId, onNavigate) {
  return function (dispatch) {
    dispatch({
      type: CLOSE_EDIT_DECK_CARD,
    });

    dispatch({
      type: CLOSE_EDIT_DECK_CARD_SUCCESS,
      payload: deckId,
    });

    onNavigate?.();
  };
}

export function removeCardFromDeck(deckId, cardId) {
    return function (dispatch) {
        dispatch({
            type: REMOVE_CARD_FROM_DECK
        });

        apiV2.patch(`/decks/${deckId}/remove-card`, { card_id: cardId })
            .then(() => {
                dispatch({
                    type: REMOVE_CARD_FROM_DECK_SUCCESS,
                    payload: cardId
                });
                Swal.fire({
                    icon: "success",
                    title: "Card Removed!",
                    timer: 2000
                });
            })
            .catch((error) => {
                dispatch({
                    type: REMOVE_CARD_FROM_DECK_ERROR,
                    payload: []
                });
                errorHandler(dispatch, error.response, API_ERROR);
            })
    }
}

export function addCardToDeck(deckId, card) {
    return function (dispatch) {
        dispatch({
            type: ADD_CARD_TO_DECK
        });

        apiV2.patch(`/decks/${deckId}/add-card`, { card_id: card.id })
            .then(() => {
                dispatch({
                    type: ADD_CARD_TO_DECK_SUCCESS,
                    payload: card
                });
                // Target the unparented-card-dialog node so the toast
                // sits inside its dialog rather than escaping to the
                // page corner (parity with v1's behaviour).
                toast.success('Card added!', {
                  timer: 2000,
                  position: 'bottom-start',
                  target: document.getElementById('unparented-card-dialog'),
                });
            })
            .catch((error) => {
                dispatch({
                    type: ADD_CARD_TO_DECK_ERROR,
                    payload: []
                });
                errorHandler(dispatch, error.response, API_ERROR);
            })
    }
}

export function saveCard(card, onSuccess) {
  return function (dispatch) {
    dispatch({
      type: SAVE_DECK_CARD,
    });

    const payload = {
      deck_id: card.deck_id || null,
      title: card.title,
      subtitle: card.subtitle || null,
      front_image_url: card.front_image_url || null,
      back_image_url: card.back_image_url || null,
      target_deeplink_image_url: card.target_deeplink_image_url || null,
      target_android_deeplink_url: card.target_android_deeplink_url || null,
      target_ios_deeplink_url: card.target_ios_deeplink_url || null,
      target_web_deeplink_url: card.target_web_deeplink_url || null,
      share_link_description: card.share_link_description || null,
      share_deeplink_url: card.share_deeplink_url || null,
      share_image_url: card.share_image_url || null,
      linked_content_button_text: card.linked_content_button_text || null,
      linked_content_button_icon_url: card.linked_content_button_icon_url || null,
      sort_order: card.sort_order ?? null,
      is_active: Boolean(card.is_active),
    };

    const request = card.id
      ? apiV2.put(`/decks/cards/${card.id}`, payload)
      : apiV2.post(`/decks/cards`, payload);

    request
      .then(() => {
        dispatch({
          type: SAVE_DECK_CARD_SUCCESS,
          payload: null,
        });
        Swal.fire({
          icon: "success",
          title: "Card Saved!",
          timer: 1000,
        }).then(() => {
          onSuccess?.();
        });
      })
      .catch(error => {
        dispatch({
          type: SAVE_DECK_CARD_ERROR,
          payload: [],
        });
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}

export function sortCards(sortedCards) {
    return function (dispatch) {
        dispatch({
            type: SORT_DECK_CARDS
        });

        const sortedIds = sortedCards.map(card => card.id);

        apiV2.put(`/decks/cards/sort-order`, { cards: sortedIds })
            .then(() => {
                dispatch({
                    type: SORT_DECK_CARDS_SUCCESS,
                    payload: sortedCards
                });
                toast.success('Cards sorted!', {
                  timer: 2000,
                  position: 'bottom-end',
                });
            })
            .catch((error) => {
                dispatch({
                    type: SORT_DECK_CARDS_ERROR,
                    payload: []
                });
                errorHandler(dispatch, error.response, API_ERROR);
            })
    }
}
